import { fieldsConnect } from "@/locale/modules/index";
import common from "@/locale/modules/common";

const login = {
  PasswordLogin: fieldsConnect(common, ["Password", "Space", "Login"]),
  VCodeLogin: fieldsConnect(common, ["VCode", "Space", "Login"]),
  PleaseEnterMobileEmail: fieldsConnect(common, [
    "PleaseEnter",
    "Mobile",
    "Divider",
    "Email",
  ]),
  PleaseEnterMobileEmailTip: fieldsConnect(common, [
    "PleaseEnter",
    "TheRight",
    "Mobile",
    "Divider",
    "Email",
  ]),
  PleaseEnterVCode: fieldsConnect(common, ["PleaseEnter", "VCode"]),
  PleaseEnterAccount: fieldsConnect(common, [
    "PleaseEnter",
    "Mobile",
    "Divider",
    "Email",
    "Divider",
    "AccountID",
  ]),
  PleaseEnterPassword: ["请输入密码", "Please Enter Your Password"],
  PleaseEnterPasswordTip: [
    "请输入账号对应的密码",
    "Please Enter The Right Password",
  ],
  PleaseEnterAccountTip: fieldsConnect(common, [
    "PleaseEnter",
    "TheRight",
    "Mobile",
    "Divider",
    "Email",
    "Divider",
    "AccountID",
  ]),
  RememberMe: ["记住账号密码", "Remember Me"],
  ContinueAgree: ["继续操作代表您同意", "By Continuing, You Agree to"],
  SignIn: ["登录", "SIGN IN"],
  DontHaveAccount: ["还没有账号? ", "Dont`t have an account? "],
  RegisterNow: ["立即注册", "Register now"],
  Organization: ["选择组织", "Organization"],
  PleaseChooseOrganization: ["请选择组织", "Please Choose Organization"],
  SignUp: ["注册", "SIGN UP"],
  PleaseEnterPasswordTipCondition: [
    "请输入8位数字和字母组合（区分大小写）",
    "Please Enter Password with 8 Digits and Letters",
  ],
  PleaseEnterPasswordConfirm: ["请确认密码", "Please Confirm Password"],
  ConsistentPasswordTip: [
    "两次输入的密码不一致",
    "Please Enter a Consistent Password",
  ],
  PleaseEnterMobile: fieldsConnect(common, ["PleaseEnter", "Mobile"]),
  HaveAccount: ["已有账号", "Existing "],
  AccountLogin: ["直接登录", "Account Login"],
  WeChatLogin: ["微信登录", "WeChat login"],
  ScanToLogInSignTrustWithWechat: [
    "使用微信扫一扫登录“签泰”",
    'Scan to log in "SignTrust" with WeChat',
  ],
  TheMobilePhoneNumberFormatIsIncorrect: [
    "手机号格式不正确",
    "The mobile phone number format is incorrect.",
  ],
  heMobilePhoneNumberAlreadyExistsPleaseLogInDirectly: [
    "手机号已存在，请直接登录",
    "The mobile phone number already exists, please log in directly",
  ],
  PleaseEnterTheCorrectVcode: [
    "请输入正确的验证码",
    "Please enter the correct Vcode",
  ],
  AreYouSureYouWantToLogOut: [
    "您确定要退出登录吗?",
    "Are you sure you want to log out?",
  ],
  ToManageAndInitiateDocumentSigning: [
    "管理和发起文件签署请访问",
    "To manage and initiate document signing, please visit",
  ],
  OrWeChatMiniProgram: ["或微信小程序", "or WeChat mini program"],
  SignTrust: ["签泰", "Sign Trust"],
  CustomerServiceHotline: ["客服电话", "Customer Service Hotline"],
};

export default login;
